import { Dropdown as DropdownBase } from '@mindz/react-admin-ui'
import Dropdown from './Dropdown'

Dropdown.Item = DropdownBase.Kaufland.Item

export default Dropdown
